import { X } from "lucide-react";
import React from "react";
import IconButton from "../../../IconButton";
import Stack from "../../../Stack";
import Typography from "../../../Typography";
import VARIANT_OPTIONS from "../../constants";
import { BaseDialogHeader, TitleContainer, UtilityIconContainer } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function DialogHeader(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    icon = _ref.icon,
    closeButtonOnClick = _ref.closeButtonOnClick,
    variant = _ref.variant;
  var IconComponent = VARIANT_OPTIONS[variant].forcedIcon ? VARIANT_OPTIONS[variant].forcedIcon : icon;
  return /*#__PURE__*/_jsxs(BaseDialogHeader, {
    variant: variant,
    children: [/*#__PURE__*/_jsxs(TitleContainer, {
      children: [VARIANT_OPTIONS[variant].titleIcon && IconComponent && /*#__PURE__*/_jsx(IconComponent, {
        color: "currentColor",
        size: "1.5rem"
      }), /*#__PURE__*/_jsxs(Stack, {
        spacing: "none",
        children: [/*#__PURE__*/_jsx(Typography, {
          color: "inherit",
          variant: "sectionTitle",
          children: title
        }), subtitle && /*#__PURE__*/_jsx(Typography, {
          color: "lowContrast",
          variant: "sectionSubtitle",
          children: subtitle
        })]
      })]
    }), VARIANT_OPTIONS[variant].headerCloseAllowed && closeButtonOnClick && /*#__PURE__*/_jsx(UtilityIconContainer, {
      children: /*#__PURE__*/_jsx(IconButton, {
        size: "compact",
        onClick: closeButtonOnClick,
        tooltipContent: "Close Dialog",
        icon: /*#__PURE__*/_jsx(X, {})
      })
    })]
  });
}
export default DialogHeader;